'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _templateObject = _taggedTemplateLiteral(['\n      background-image: url(', ');\n\n      @media (min-width: ', ') {\n        background-image: url(', ');\n      }\n    '], ['\n      background-image: url(', ');\n\n      @media (min-width: ', ') {\n        background-image: url(', ');\n      }\n    ']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactEmotion = require('react-emotion');
var _variables = require('../utility/variables');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var Hero = function Hero(props) {
  var bgImage = (0, _reactEmotion.css)(_templateObject, props.bgMobile || props.bgDesktop, _variables.mediaQueries.sm, props.bgDesktop || props.bgMobile);
  return _react2.default.createElement('div', {
    className: 'hero ' + props.className + ' ' + bgImage
  }, props.children);
};
Hero.defaultProps = {
  bgMobile: '',
  bgDesktop: '',
  className: '',
  children: null
};
Hero.propTypes = {
  bgMobile: _propTypes2.default.string,
  bgDesktop: _propTypes2.default.string,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string
};
exports.default = Hero;